/**
 * The franchise's name set in a tall condensed typeface (Anton, free to use) with a
 * garnet slash underneath. It nods at the comic-book wordmark style without copying
 * anyone's logo: our colours, our lockup — no red box behind the letters.
 */
export default function FranchiseMark({ name, size = "md", className = "" }) {
  const sizes = {
    sm: "text-2xl",
    md: "text-4xl md:text-5xl",
    lg: "text-6xl md:text-8xl",
    xl: "text-7xl md:text-[10rem] leading-[0.85]",
    banner: "text-6xl sm:text-7xl",
  };
  return (
    <span className={`relative inline-block ${className}`} data-testid="franchise-mark">
      <span
        className={`relative block font-wordmark uppercase text-white leading-[0.95] ${sizes[size] || sizes.md}`}
        style={{ textShadow: "0 0 40px rgba(194,16,46,0.55), 0 6px 30px rgba(0,0,0,0.6)" }}
      >
        {name}
      </span>
      <span className="block h-[0.1em] min-h-[3px] w-[104%] -ml-[2%] mt-[0.12em] -skew-x-[24deg] bg-gradient-to-r from-[#880015] via-[#C2102E] to-transparent" style={{ fontSize: "inherit" }} aria-hidden="true" />
    </span>
  );
}
